export default "__VITE_ASSET__CFuP6NAL__"